import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "addition-drawer" }

import Drawer from '../common/Drawer.vue'
import { ref, computed } from 'vue'
import AdtCfg from './AdtCfg.vue'
import AdtOrder from './AdtOrder.vue'
import DeliAdt from './DeliAdt.vue'
import { useStore } from 'vuex'
import { confirmEdit } from '@/util/useConfirm'

export default /*#__PURE__*/_defineComponent({
  props: ['type', 'title'],
  emits: ['update:list', 'commit', 'update', 'save', 'close'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()
/**
 * type 附加项类型 AdtCfg 类目附加项 AdtOrder 商品附加项 DeliAdt 发货附加项
 */

/**
 * 'update:list', 'commit' AdtOrder组件
 * 'update' AdtCfg组件
 *
 */

const visible = ref(true)
const componentName = computed(() => {
  return props.type === 'AdtCfg' ? AdtCfg
    : props.type === 'AdtOrder' ? AdtOrder
      : props.type === 'DeliAdt' ? DeliAdt : ''
})
const comRef = ref()
const closeDialog = () => {
  visible.value = false
  setTimeout(() => {
    emits('update:list', null)
    store.commit('status/editing', false)
    emits('close')
  }, 500)
}

const close = () => {
  // 商品附加项和类目附加项需要校验操作
  confirmEdit(() => closeDialog(), () => { })
}
const commit = (e: any) => {
  emits('commit', e)
  closeDialog()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Drawer, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    onBeforeClose: close,
    onOk: close,
    title: __props.title,
    showBtn: false,
    size: "740px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentName)), _mergeProps(_ctx.$attrs, {
          ref: (_value, _refs) => {
            _refs['comRef'] = _value
            comRef.value = _value
          },
          onCommit: commit,
          onUpdate: _cache[0] || (_cache[0] = ($event: any) => (emits('update'))),
          onBeforeClose: closeDialog,
          onSave: _cache[1] || (_cache[1] = (e) => emits('save', e)),
          key: Date.now()
        }), {
          historyAdt: _withCtx(() => [
            _renderSlot(_ctx.$slots, "historyAdt")
          ]),
          _: 3
        }, 16))
      ])
    ]),
    _: 3
  }, 8, ["visible", "title"]))
}
}

})